import { FlexContainer } from '@taxdown/piccolo-web';
import FlowColLayout from 'Components/Layouts/FlowColLayout';
import Trans from 'Components/Trans';
import { lottiesPaths } from 'Constants/lottiesPaths';
import * as Styled from '../../styles';

const TransitionLoader = (): JSX.Element => (
  <FlowColLayout section="result" isFlow>
    <FlexContainer direction="column" align="center" justify="center" fullHeight>
      <Styled.TransitionContent
        direction="column"
        fullHeight
        fullWidth
        align="center"
        justify="center"
      >
        <Styled.Lottie options={{ path: lottiesPaths.RESULT_TRANSITION }} />
        <Styled.Text type="headline" size="S_L_M" color="success_strong" align="center">
          <Trans i18nKey="ResultLoader.title" ns="result" />
        </Styled.Text>
      </Styled.TransitionContent>
    </FlexContainer>
  </FlowColLayout>
);

export default TransitionLoader;
